import React, { Component } from 'react';
import { getPlans, createPlan, updatePlan, deletePlan } from './actions';
import './style.scss';
import { Table, Popconfirm } from 'antd';
import FormModal from './components/FormModal';
import { CloseOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types'

class Plans extends Component {
  static contextTypes = {formatMessage: PropTypes.any}

  constructor(props) {
    super(props)
    this.state = {
      spinner: true,
      plans: [],
      isOpen: false,
      item: {}
    }
  }
  
  async componentDidMount(){
    try {
      const plans = await getPlans();
      this.setState({
        plans,
        spinner: false
      })
    } catch (error) {
      
    }
  }

  submit = async (data) => {
    const {plans} = this.state;
    
    if(data.id){
      let plan = await updatePlan(data);
      this.setState({plans: plans.map(i => i.id == plan.id ? plan : i)})
    } else {
      let plan = await createPlan(data);
      this.setState({plans: [...plans, plan]})
    }
    this.setState({isOpen: false, item: {}})
  }

  render() {
    const {formatMessage} = this.context;
    
    const {plans, isOpen, item, spinner} = this.state;
    const columns = [
      {
        title: formatMessage('titlePlanPayment'),
        dataIndex: 'title',
        key: 'title',
      }, 
      {
        title: formatMessage('MonthsPlanPayment'),
        dataIndex: 'months',
        key: 'months',
      },
      {
        title: formatMessage('AmountPlanPayment'),
        dataIndex: 'amount',
        key: 'amount',
      },
      {
        title: '',
        render: (item) => {
          return <div className="actions-table">
            <i onClick={() => {this.setState({isOpen: true, item})}} className="icon far fa-edit"></i>
            <Popconfirm
              title={formatMessage('msgDeletePlanPayment')}
              icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
              onConfirm={ async() => {
                await deletePlan(item);
                this.setState({
                  plans: plans.filter(i => i.id != item.id),
                })
              }}
            >
              <CloseOutlined />
            </Popconfirm>
          </div>
        },
        key: 'actions',
      },
    ];
    return (
      <div className="AdminPlans row">
        <div className="col-md-12">
          <div className="actions">
            <button
              className="btn btn-primary"
              type="submit"
              onClick={() => this.setState({isOpen: true, item: {}})}
            >{formatMessage('AddNewPlanPayment')}</button>
          </div>
          {isOpen && <FormModal 
            item={item} 
            initialValues ={item} 
            save={this.submit} 
            isOpen={isOpen} 
            handleClose={() => {this.setState({isOpen: false, item: {}})}} 
          />}
          <Table loading={spinner} dataSource={plans} columns={columns} bordered pagination={false} />
        </div>
      </div>
    );
  }
}

export default Plans;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/AdminPanel/Plans/index.jsx